interface ItemProps {
  children: ({ isActive }: { isActive?: boolean }) => void;
  isActive?: boolean;
  className?: string;
  onMouseEnter?: () => void;
  onMouseLeave?: () => void;
}

const Item = ({ children, isActive, ...passThrough }: ItemProps): JSX.Element => {
  return (
    <>
      <li {...passThrough} className="navbar-desktop-list-item">
        {children({ isActive }) as any}
      </li>
      <style jsx>
        {`
          .navbar-desktop-list-item {
            padding: 0;
          }
        `}
      </style>
    </>
  );
};

export default Item;
